export default __webpack_public_path__ + "static/media/note-screenshot-06.a3fe1bf4.png";